import * as React from 'react';
import { forwardRef } from 'react';

var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var SvgFacebookCircle = function SvgFacebookCircle(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 1024 1024",
    fill: "currentColor",
    className: "Icon ".concat((props === null || props === void 0 ? void 0 : props.className) || ''),
    ref: ref
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 512C0 229.2 229.2 0 512 0s512 229.2 512 512-229.2 512-512 512S0 794.8 0 512m565.4 301V534.5h76.9l10.2-96h-87.1v-48c0-25 2.4-38.5 38.3-38.5h48.1v-96H575c-92.4 0-124.9 46.6-124.9 124.9v57.6h-57.6v96h57.6V813z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFacebookCircle);

export { ForwardRef as default };
